import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';
import TitleBar from '../../components/title_bar';
import RecipeList from '../../components/recipe_list';
import ShopListList from '../../components/shop_list_list';
import { getReduxStore } from '../../globals';
import setShoppingList from '../../actions/set_shopping_list';
import fetchAccountRecipes, { recipeSelected } from '../../actions/acct_recipes_actions';
import {fetchAccountShopLists} from '../../actions/shopping_list_list_actions';
import fetchAccountItems from '../../actions/item_actions';
import fetchMeasureList from '../../actions/ref_data_actions';
import AddBtn from '../../images/add.png';
import '../../css/common.css';
import '../../css/main.css';

class Main extends Component {

  constructor(props) {
    super(props);

    this.state = { temp: true }
  }

  getAcctData() {
    const st = getReduxStore().getState();

    if (_.isEmpty(st.measure_List)) {
      this.props.dispatch(fetchMeasureList());
    }

    if (_.isEmpty(st.shop_list_list)) {
      this.props.dispatch(fetchAccountShopLists(100000));
    }
    if (_.isEmpty(st.recipe_list)) {
      this.props.dispatch(fetchAccountRecipes(100000));
    }

    if (_.isEmpty(st.item_list)) {
      this.props.dispatch(fetchAccountItems(100000));
    }

  }

  componentDidMount() {
    
    this.getAcctData();

    document.title = "Your stuff";
  }

  onRecipeSelect (recipe) {
    getReduxStore().dispatch(recipeSelected(recipe));
    this.props.history.push(`/recipe`);
  }

  onShopListSelect (shopList) {
    getReduxStore().dispatch(setShoppingList(shopList));
    this.props.history.push(`/shop_list`);
  }

  render() {
    return (
       <div id="main-bk-div">
        <TitleBar showContact={true} />
        <div id="mainArea" className="title-ba1r-offset">
          <div id="divRecipeHdr" className="label-font main-font sectionHdr">
            <div>Your Recipes</div>
            <div><img  alt="Add Recipe" title="Add Recipe" src={AddBtn} className="addBtn"/></div>
          </div>
          <div id="divRecipeList" className="grn-brdr">
              <RecipeList onRecipeSelect={this.onRecipeSelect.bind(this)}/>
          </div>
          <div id="divShopListHdr" className="label-font main-font sectionHdr">
            <div>Your Shopping Lists</div>
            <div><img alt="Add Shopping List" title="Add Shopping List" src={AddBtn} className="addBtn"/></div>
          </div>
          <div id="divShopListList"  className="grn-brdr">
              <ShopListList className="brdr" onShopListSelect={this.onShopListSelect.bind(this)}/>
          </div>
        </div>
       </div>
    )
  }
}

const mapStateToProps = state => ({
/*  products: state.products.items,
  loading: state.products.loading,
  error: state.products.error*/
});

export default connect(mapStateToProps)(Main);


// WEBPACK FOOTER //
// ./src/pages/main/main.js